import { Component, Input } from '@angular/core';
import { InventoryVariable } from '../variable-details/variable-details.model';

@Component({
    selector: 'adm4-inventory-variable',
    template: `
    <label class='full-width inventory-variable'>
      @if (inventoryVariable.sourceName) {
        <span class='inventory-variable-source'>{{inventoryVariable.sourceName}}</span>
      }
      <textarea adm4Autosize [data]='inventoryVariable.value' class='admn4-textarea-input full-width form-control' [value]='inventoryVariable.value' readonly></textarea>
    </label>
    
    `,
    styleUrls: ['./inventory-variable.component.scss'],
    standalone: false
})
export class InventoryVariableComponent {
  @Input() inventoryVariable: InventoryVariable;
}
